import { createSlice } from "@reduxjs/toolkit";
import { PostAudioProps } from "./postAudio";

const initialState: PostAudioProps.State = {
  uploadedAudio: {} as PostAudioProps.Audio,
  audioBackgroundImage: {} as PostAudioProps.State["audioBackgroundImage"],
  gradients: [],
  audio_id: "",
  isUploading: false,
};

const slice = createSlice({
  name: "postAudio",
  initialState,
  reducers: {
    setUploadedAudio: (state, action: PostAudioProps.setUploadedAudio) => {
      state.uploadedAudio = action.payload;
    },
    setUploadedAudioDraft: (
      state,
      action: PostAudioProps.setUploadedAudioDraft
    ) => {
      state.audio_id = action.payload.audio_id;
      state.gradients = action.payload.gradients;
      state.audioBackgroundImage.background_type = "gradient";
      state.audioBackgroundImage.background_value = JSON.stringify(
        action.payload.gradients[0].gradient
      );
    },
    setAudioBackgroundImage: (
      state,
      action: PostAudioProps.setAudioBackgroundImage
    ) => {
      state.audioBackgroundImage = action.payload;
    },
    deleteAudioBackgroundImage: (state) => {
      state.audioBackgroundImage.background_type = "gradient";
      state.audioBackgroundImage.background_value = JSON.stringify(
        state.gradients[0].gradient
      );
      state.audioBackgroundImage.id = state.audio_id;
    },
    setIsUploading: (state, action: PostAudioProps.setIsUploading) => {
      state.isUploading = action.payload;
    },
    reset: () => initialState,
  },
});

export const postAudioActions = slice.actions;
export const postAudioReducer = slice.reducer;
